export enum PageFilterGroupType {
  Bool = 'bool',
  Custom = 'custom',
  Date = 'date',
  Number = 'number',
  Search = 'search',
  Select = 'select',
  String = 'string'
}
